module.exports = __webpack_public_path__ + "assets/aeda0a4d5acc7fb299730ee37c1a7766.png";